import {Settings as BaseSettings} from 'services/sports/default/settings';

export default class SettingsClassic extends BaseSettings {
    saveOptimizationSettings({incomingValues}) {
        this.exec('saveCorrelationStackingSettings', incomingValues);
        this.exec('saveKeyPlayerStackingGroups', incomingValues);
    }
}
